import React from "react";
import moment from 'moment';

const Date = ({ date = null }) => {
    if (typeof date == "object" && date != null && date != ""){
        return moment(parseInt(date.$date.$numberLong)).format('YYYY-MM-DD HH:mm:ss')
    }else if(typeof date == "string" && date != null && date != ""){
        return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }else{
        return date
    }
};

export default Date;
